<template>
  <a-select :mode="multiple ? 'multiple' : undefined" v-model:value="valueState" style="width: 300px"
    placeholder="Pilih Distributor Derivatives" allow-clear show-search not-found-content="Tidak ditemukan"
    option-filter-prop="label" option-label-prop="label" @search="onSearch"
    @dropdownVisibleChange="() => (state.params.q = '')" v-bind="$attrs" :loading="state.loading" :show-arrow="true">
    <a-select-option v-for="d in state.data" :key="d.id" :label="d.name">
      <!-- eslint-disable vue/no-v-html -->
      <span v-html="highlight(d.name)"></span>
      <!--eslint-enable-->
    </a-select-option>
  </a-select>
</template>

<script>
import { onMounted, ref, toRefs, reactive, watch } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce } from 'lodash'

export default {
  props: {
    value: {
      default: () => [],
      type: Array,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    type: {
      type: Number,
      default: null,
    },
  },
  // emits: ['update:value'],
  emits: ['update:value', 'update:items'],
  setup(props, { emit }) {
    const state = reactive({
      endpoint: '/api/filter/distributor-derivatives-all',
      loading: false,
      data: [],
      params: {
        q: '',
      },
    })

    const valueState = useVModel(props, 'value')

    const fetchLists = () => {
      state.loading = true

      const params = {
        ...state.params,
      }

      if (props.type !== null) {
        params.type = props.type
      }

      apiClient
        .get(state.endpoint, { params })
        .then(({ data }) => {
          state.data = data.sort((a, b) =>
            a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
          )
        })
        .finally(() => {
          state.loading = false
        })
    }

    const onSearch = (value) => {
      state.params.q = value
    }

    const highlight = value => {
      return value.replace(new RegExp(state.params.q, 'gi'), match => {
        return `<span style="background-color: yellow;">${match}</span>`
      })
    }

    watch(
      [() => valueState.value, () => state.data],
      ([val]) => {
        let selectedItems = []

        if (props.multiple) {
          if (!Array.isArray(val)) return

          selectedItems = state.data.filter(item =>
            val.includes(item.id),
          )
        } else {
          selectedItems = state.data.filter(item =>
            item.id === val,
          )
        }

        emit('update:items', selectedItems)
      },
      { immediate: true },
    )

    onMounted(() => {
      fetchLists()
    })

    watch(state.params, debounce(() => {
      fetchLists()
    }, 300))

    return {
      state,
      valueState,
      highlight,
      onSearch,
    }
  },
}
</script>

<style></style>